export enum OPERATOR_LOGICAL {
    AND = 'AND',
    OR = 'OR',
}
